// // src/components/dashboard/StatsCard.jsx
// import React from 'react';

// const StatsCard = ({ title, value, icon, change, trend }) => {
//   return (
//     <div className="bg-white overflow-hidden shadow rounded-lg">
//       <div className="p-5">
//         <div className="flex items-center">
//           <div className="flex-shrink-0">
//             {icon}
//           </div>
//           <div className="ml-5 w-0 flex-1">
//             <dl>
//               <dt className="text-sm font-medium text-gray-500 truncate">
//                 {title}
//               </dt>
//               <dd>
//                 <div className="text-lg font-medium text-gray-900">
//                   {value}
//                 </div>
//               </dd>
//             </dl>
//           </div>
//         </div>
//       </div>
//       <div className="bg-gray-50 px-5 py-3">
//         <div className="text-sm">
//           <div className="flex items-center justify-between">
//             <span className="font-medium text-gray-500">
//               {trend === 'up' ? 'Increased' : 'Decreased'} by
//             </span>
//             <span 
//               className={`
//                 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
//                 ${trend === 'up' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}
//               `}
//             >
//               {trend === 'up' ? (
//                 <svg className="-ml-1 mr-0.5 flex-shrink-0 h-4 w-4 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
//                   <path fillRule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
//                 </svg>
//               ) : (
//                 <svg className="-ml-1 mr-0.5 flex-shrink-0 h-4 w-4 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
//                   <path fillRule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clipRule="evenodd" />
//                 </svg>
//               )}
//               {Math.abs(change)}%
//             </span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StatsCard;
// src/components/dashboard/StatsCard.jsx
// src/components/dashboard/StatsCard.jsx
import React from 'react';

const StatsCard = ({ title, value, icon, change, trend, subtitle, isSelected = false }) => {
  const formatChange = (change) => {
    if (change === undefined || change === null || change === 0) return null;
    return Math.abs(change);
  };

  const getTrendColors = (trend) => {
    switch (trend) {
      case 'up':
        return 'text-green-600';
      case 'down':
        return 'text-red-600';
      default:
        return 'text-gray-500';
    }
  };

  const getIconBgColor = (trend) => {
    switch (trend) {
      case 'up':
        return 'bg-green-100';
      case 'down':
        return 'bg-red-100';
      default:
        return 'bg-red-100';
    }
  };

  const formattedChange = formatChange(change);

  return (
   <div
  className={`bg-white overflow-hidden shadow-lg rounded-xl transition-all duration-300 hover:shadow-2xl border-2 h-32 sm:h-36 md:h-40 flex flex-col ${
    isSelected
      ? 'border-red-500 shadow-xl scale-105'
      : 'border-gray-100 hover:border-red-300'
  } transform hover:-translate-y-1`}
>
    <div className="px-2 py-2 sm:px-4 sm:py-4 md:px-6 md:py-5 flex-1 flex flex-col justify-center">
      <div className="flex items-start flex-wrap sm:flex-nowrap sm:items-center">
          <div className={`flex-shrink-0 p-1.5 sm:p-2 md:p-3 rounded-full ${getIconBgColor(trend)} transition-all duration-300`}>
            {icon}
          </div>
          <div className="ml-2 sm:ml-3 md:ml-5 w-0 flex-1 min-w-0">
            <dl>
            <dt className="text-xs sm:text-sm font-medium text-gray-600 leading-tight break-words">
                {title}

              </dt>
              <dd>
                <div className="text-lg sm:text-xl font-bold text-gray-900 tracking-tight">
                  {value}
                </div>
                {subtitle && (
                  <div className="text-xs text-gray-400 mt-1 leading-tight">
                    {subtitle}
                  </div>
                )}
              </dd>
            </dl>
          </div>
        </div>



        {(title.includes('Sales') ||
          title.includes('Orders') ||
          title.includes('Purchased') ||
          title.includes('Returns') ||
          title.includes('Low Stock')) && (
            <div className="mt-4">

            </div>
          )}
      </div>
    </div>
  );
};

export default StatsCard;